import { useEffect } from "react";
import { RefreshTokenCitroenProps } from "../../interfaces/components";

const RefreshTokenCitroen = ({expirationTime,getCitroenToken}: RefreshTokenCitroenProps) => {
    useEffect(() => {
        let timer: any = null;
        if (expirationTime) {
            timer && clearTimeout(timer)
            const fiveMinsBeforeExpire = (expirationTime) + (15 * 60 * 1000) - (5 * 60 * 1000);
            const today = new Date().getTime();
            if(fiveMinsBeforeExpire > today){
                const fiveMinutesBeforeExp = (Number(expirationTime) + (15 * 60 * 1000)) - (5 * 60 * 1000);
                const waitingTime = fiveMinutesBeforeExp - today;
                timer = setTimeout(() => { 
                    getCitroenToken();
                }, waitingTime);
            }else{
                getCitroenToken();
            }
        }
        else{
            getCitroenToken();
        }
    }, [expirationTime]);
    
    return null;
};

export default RefreshTokenCitroen;